import { Locale } from '@ps-smart-cp/ppfw-client';
import { rawValueToEnum } from '../utils';

/** 任意項目のマスタ参照 */
enum MstReference {
  notRefer = '1',
  refer = '2',
  optionallyRefer = '3',
}

const nameConfig = {
  notRefer: new Map([[Locale.ja, '参照しない']]),
  refer: new Map([[Locale.ja, '参照する']]),
  optionallyRefer: new Map([[Locale.ja, '参照任意']]),
};

const toEnum = rawValueToEnum(MstReference, MstReference.notRefer);

export const mstReference = {
  enum: MstReference,
  nameConfig,
  toEnum,
};
export type { MstReference };
